import React, { useEffect } from "react";
import readConfig from "../../utils/readClientConfiguration";
import productionConfiguration from "../../config/default.json";

const currencyCode = readConfig(productionConfiguration, "currencyCode").toUpperCase();

function prepareString(name) {
  if (!name) return "";
  return name.replace(/"/g, "'").replace(/\\/g, "/");
}

export default function StructuralDataProduct({ product }) {
  if (!product) {
    return null;
  }

  const {
    sku = "",
    name = "",
    gallery = [],
    description = {},
    is_saleable = false,
    price_range = {},
    __typename,
    items = [],
    prices
  } = product;

  function getLowestPriceObject(prices) {
    if (!prices || prices.length === 0) return null;

    return prices.reduce((lowest, current) => {
      const currentAmount = parseFloat(current.amount);
      const lowestAmount = parseFloat(lowest.amount);
      return currentAmount < lowestAmount ? current : lowest;
    }, prices[0]);
  }

  const lowestPrice=getLowestPriceObject(prices)
  // Obliczenie ceny końcowej
  let final_price = parseFloat(lowestPrice?.['amount']) || 0;

  if (__typename === "GroupedProduct" && items.length > 0) {
    final_price = items[0]?.product?.price_range?.minimum_price?.final_price?.value ?? final_price;
  }

  // Czyszczenie opisu
  const cleanDescription = description?.html
      ? description.html.replace(/<br>/g, " ").replace(/(<([^>]+)>)/gi, " ")
      : "";

  // Wybór pierwszego obrazu z galerii
  const firstImage = gallery.length > 0
      ? gallery.reduce((prev, curr) => (prev.position < curr.position ? prev : curr), gallery[0])
      : null;
  const firstImageUrl = firstImage?.large_image_url || firstImage?.medium_image_url || firstImage?.small_image_url || "";

  // Przygotowanie danych JSON-LD
  const params = {
    "@context": "https://schema.org",
    "@type": "Product",
    description: prepareString(cleanDescription),
    name: prepareString(name),
    image: firstImageUrl,
    sku,
    offers: {
      "@type": "Offer",
      availability: is_saleable ? "https://schema.org/InStock" : "https://schema.org/OutOfStock",
      price: final_price,
      priceValidUntil: lowestPrice && lowestPrice['promotion_end'] && lowestPrice['promotion_end'].trim() ? lowestPrice['promotion_end'].split(" ")[0] : null,
      priceCurrency: currencyCode,
    },
  };

  // Dodajemy skrypt LD+JSON do head
  useEffect(() => {
    if (typeof document !== 'undefined') {
      try {
        // Usuwamy poprzedni skrypt, jeśli istnieje
        const existingScript = document.querySelector('script[data-product-json]');
        if (existingScript) {
          existingScript.remove();
        }
        
        // Tworzymy nowy element skryptu tylko jeśli mamy pełne dane do jego zbudowania
        if (params && params.name && params.sku) {
          const script = document.createElement('script');
          script.setAttribute('type', 'application/ld+json');
          script.setAttribute('data-product-json', 'true');
          script.textContent = JSON.stringify(params, null, 2);
          document.head.appendChild(script);
        }
      } catch (error) {
        console.error('Error adding product structured data:', error);
      }
    }
  }, [product, params]);
  
  // Ten komponent nie renderuje nic
  return null;
}